import React, { useMemo } from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FileInput, FileInputType } from '../../../../components/file-input';
import { calcCampaignTotals } from '../../../../utils';
import { useContext } from 'react';
import { ExchangeRatesContext } from '../../../../contexts/exchange-rates-context';
import { useLocation, useOutletContext } from "react-router-dom";
import { CampaignOutletContextValue } from "../../form";
import { ModalWindow } from '../../../../components/ModalWindow';
import {
    Alert,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Checkbox, FormControlLabel,
    FormLabel,
    Autocomplete,
    Typography,
    TextField
} from "@mui/material";
import { useUserContext } from "../../../../contexts/user-context";
import { Cancel, Check, Undo } from "@mui/icons-material";
import { CampaignStatusSelect } from "../../../../components/MaterialSelects/CampaignStatusSelect";
import { useDaybookContext } from "../../../../contexts/Daybook/DayBookContext";
import { IsoDatePicker } from '../../../../components/IsoDatePicker';

const CampaignConfirmDialog = ({ setValue, setTransient, transientValues, values, done, isShown, isAutoUpgrade, setAutoUpgrade, daybook }) => {
    //const [tempFiles, setTempFiles] = useState([]);
    console.log('CCD?');
    const panelBookings = values.panelBookings;
    const authorizationFiles = values.authorizationFiles;
    const tempFiles = transientValues?.tempFiles || [];
    const user = useUserContext();
    const exchangeRatesContext = useContext(ExchangeRatesContext);
    //var authorizationUploads = values.authorizationUploads || [];
    let hasUpgrades = 0;
    panelBookings?.forEach(function (panelBooking) {
        if (panelBooking.status === 'Pencil') {
            hasUpgrades++;
        }
    });

    console.log('bookings are', panelBookings, hasUpgrades);
    console.log('re-rendering CCD', tempFiles, tempFiles.length);
    const changeTempFiles = (evt) => {
        //const val = evt.target.value(tempFiles);
        console.log('change Temp Files',evt);
        setTransient('tempFiles', evt.target.value);
        //setTempFiles(val);
    };
    let overdrawn = false;
    if (isShown) {
        const totals = calcCampaignTotals({ campaignValues: values, exchangeRates: exchangeRatesContext, daybookConfig: daybook });
        overdrawn = (values.clientCompany && (values.clientCompany.credit_limit < values.clientCompany.current_credit + totals.preVatTotal));
    }
    const onOk = useCallback(() => {
        console.log(tempFiles, authorizationFiles.length, tempFiles.length);
        if (overdrawn && !user.hasPermission('campaigns.exceed_credit_limit')) return;
        if (!tempFiles.length && (!authorizationFiles.length)) {
            alert('Please select a file');
            return;
        }
        if (tempFiles) {
            tempFiles.forEach((v) => {
                authorizationFiles.push(v);
            });
        }
        console.log('doing done#?0');
        setValue('authorizationFiles', [...authorizationFiles]);
        console.log('doing done#?1');
        setTransient('tempFiles', []);
        console.log('doing done#?2',isAutoUpgrade,hasUpgrades);
        console.log('doing done#?3');
        done(true);
    }, [tempFiles, authorizationFiles, setValue, done, overdrawn]);

    const onCancel = useCallback(() => {
        setTransient('tempFiles', []);
        //        setTempFiles([]);
        done(false);
    }, [done, setValue]);
    if (!isShown) {
        return null;
    }
    return (<ModalWindow
        onClose={onCancel}
        isOpen={isShown}
        actions={
            <>
                <Button onClick={onCancel}>Do not confirm campaign</Button>
                <Button onClick={onOk} variant="contained">Confirm campaign</Button>
            </>
        }
        header={"Confirm Campaign"} maxWidth="md">
        <>
            {overdrawn && !user.hasPermission('campaigns.exceed_credit_limit') && <Alert severity="warning">
                This campaign will not be confirmed as doing so will exceed the client&quot;s credit limit.
                Please contact accounts who will either alter the limit or raise a pro forma invoice in order to secure upfront payment from
                the client.
            </Alert>}
            {overdrawn && user.hasPermission('campaigns.exceed_credit_limit') && <Alert severity="warning">
                Caution: this campaign will exceed the client&quot;s credit limit.
                You have permission to confirm this campaign, but please ensure that proof of pre-payment has been uploaded below.
            </Alert>}

            {!authorizationFiles?.length && !tempFiles?.length &&
                <Alert severity="info"><p>No authorization files have been uploaded yet.  Please upload one or more documents to show that the client has confirmed
                    this campaign.</p>
                    <FileInput
                        showPreview={true} type={FileInputType.File} multiple={true} maxSize={320}
                        label="Select any relevant File(s)" name="tempFiles" fileType="AU" value={tempFiles} onChange={changeTempFiles} />
                </Alert>
            }
            {(authorizationFiles?.length > 0 || tempFiles?.length > 0) &&
                <Alert severity="info"><p>One or more authorization files have been uploaded for this campaign.  You may add more files below or from the main page.</p>
                    <FileInput showPreview={true} type={FileInputType.File} multiple={true} maxSize={320}
                        label="Select any additional files" name="tempFiles" fileType="AU" value={tempFiles} onChange={changeTempFiles} />
                </Alert>
            }
            {hasUpgrades > 0 &&
                <React.Fragment>
                    <Alert severity="info"><p>There are {hasUpgrades} Pencil panel booking(s) that can upgraded to
                        Booked when the campaign is saved.</p>
                        <FormControlLabel control={<Checkbox checked={isAutoUpgrade} onChange={setAutoUpgrade} />} label="Update all pencil panel bookings on save" />
                    </Alert>
                </React.Fragment>
            }
        </>
    </ModalWindow>);
};
CampaignConfirmDialog.propTypes = {
    done: PropTypes.func,
    isShown: PropTypes.bool,
    isAutoUpgrade: PropTypes.bool,
    setAutoUpgrade: PropTypes.func,
    values: PropTypes.object,
    setValue: PropTypes.func
};


type CampaignStatusPaneProps = {
    initialValues?: any;
    setValue?: any;
    setTransient?: any;
    transientValues?: any;
    values?: any;
    onChange?: any;
    loading?: any;
    readOnly?: any;
    errors?: any;
};
const CampaignStatusPane = ({ initialValues, setValue, setTransient, transientValues, values, onChange, loading, readOnly, errors }: CampaignStatusPaneProps) => {
    const [showDialogCancel, setShowDialogCancel] = useState(false);
    const [showDialogConfirm, setShowDialogConfirm] = useState(false);
    const daybook = useDaybookContext();
    
    const user = useUserContext();
    const { inProductionLocked } = useOutletContext<CampaignOutletContextValue>();
    const location = useLocation();
    // The confirm-flow target follows the campaign's own type, with the same
    // values-first / route-fallback pattern as the form's tab-set derivation.
    const isCreativeStudio = (values?.type || (location.pathname.startsWith('/cs-campaigns') ? 'creative_studio' : 'standard')) === 'creative_studio';
    const campaignConfirmed = (isDone) => {
        if (isDone) {
            setValue('status', isCreativeStudio ? 'In Production' : 'Confirmed');
        }
        setShowDialogConfirm(false);
    };
    const setAutoUpgrade = useCallback((evt) => {
        setTransient('auto_upgrade', evt.target.checked);
    }, [setTransient]);
    const field = {
        onChange: onChange,
        loading: loading,
        readOnly: readOnly
    };
    const status = values?.status;
    const options = [];
    const isPaidLikePending = useMemo(() => ['Paid', 'Part Paid'].includes(status ?? ''), [status]);
    const PaidFields = (
        <div className="grid12" style={{ marginTop: '0.75rem' }}>
            <IsoDatePicker
                name="paid_date"
                label="Payment Date"
                value={values.paid_date ?? ''}
                {...field}
                error={!!errors?.paid_date}
                className="grid12-6"
                readOnlyMode="field"
            />
            <Autocomplete
                className="grid12-6"
                options={["Natwest GBP", "Natwest USD", "Natwest Euro", "Citizens", "Paypal GBP", "Paypal USD", "CCF"]}
                value={values.payment_bank ?? null}
                onChange={(_, v) => setValue("payment_bank", v ?? "")}
                disabled={readOnly}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    name="payment_bank"
                    label="Bank"
                    error={!!errors?.payment_bank}
                    helperText={errors?.payment_bank}
                    />
                )}
            />
        </div>
    );
    if (status != initialValues.status) {
        options.push(
            <Card className="grid12-6" key="allow">
                <CardHeader title="Status" />
                <CardContent><Typography>
                    You have changed the status of this campaign, please save before continuing.
                </Typography>
                {isPaidLikePending && daybook?.theme != 'daybook' && PaidFields}
                </CardContent>
            </Card>
        );
    } else {
        let seen = false;
        if (inProductionLocked) {
            seen = true;
            options.push(
                <Card variant="elevation" className="grid12-6" key="status">
                    <CardHeader title="Status" />
                    <CardContent>
                        <Typography>
                            This campaign is <b>In Production</b> and can only be edited by users with the in-production edit permission.
                        </Typography>
                    </CardContent>
                </Card>);
        }
        if (status === 'Draft' && !readOnly && !user.hasPermission('campaigns.skip_quote')) {
            seen = true;
            options.push(
                <Card className="grid12-6" key="quote">
                    <CardHeader title="Draft" />
                    <CardContent>
                        <Typography>
                            The campaign status is <b>Draft</b>. To allow the e-contract to be viewed/signed, the campaign must be <b>Quote</b>.
                            When <b>Quote</b> prices cannot be changed and any exchange rates will be fixed, reverting back into <b>Draft</b> state will allow
                            prices to be changed, but will invalidate any issued contracts.
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Button variant="contained" onClick={() => {
                            setValue('status', 'Quote');
                        }} startIcon={<Check />}>Finalize quote, fix prices and allow contract functionality</Button>
                        <Button color="error" onClick={() => {
                            setShowDialogCancel(true);
                        }} startIcon={<Cancel />}>Cancel Campaign</Button>
                    </CardActions>
                </Card>);
        }
        if (status === 'Quote' && !readOnly && !user.hasPermission('campaigns.skip_quote')) {
            seen = true;
            options.push(
                <Card variant="elevation" className="grid12-6" key="status">
                    <CardHeader title="Status" />
                    <CardContent>
                        <Typography>The campaign status is <b>Quote</b>.  Prices cannot be changed and any exchange rates are fixed.
                            To confirm the campaign you must obtain some documentation showing authorization by the client.</Typography>
                    </CardContent>
                    <CardActions>
                        <Button onClick={() => {
                            setShowDialogConfirm(true);
                        }} variant="outlined" startIcon={<Check />}>Confirm Campaign</Button>
                        <Button color="error" onClick={() => {
                            setShowDialogCancel(true);
                        }} variant="outlined" startIcon={<Cancel />}>Cancel Campaign</Button>
                        <Button onClick={() => {
                            setValue('status', 'Draft');
                        }} variant="outlined" startIcon={<Undo />}>Revert to Draft status, cancelling any e-contracts and resetting any exchange rates</Button>
                    </CardActions>
                </Card>);
        }
        if (!seen) {
            options.push(
                <Card variant="elevation" className="grid12-6" key="status">
                    <CardHeader title="Status" />
                    <CardContent>
                        <CampaignStatusSelect simpleSelect={true} {...field} valueIsId={true} includeInProduction={isCreativeStudio} value={values.status} name="status" menuPlacement="auto" label="Campaign Status" />
                        {isPaidLikePending && daybook?.theme != 'daybook' && PaidFields}
                    </CardContent>
                </Card>);
        }
    }

    return (
        <React.Fragment>
            <ModalWindow
                header="Cancel Campaign"
                onClose={() => { setShowDialogCancel(false) }}
                actions={<>
                    <Button key="no" onClick={() => { setShowDialogCancel(false); }
                    }>No, return to campaign view</Button>
                    <Button key="yes" onClick={() => {
                        setValue('status', 'Cancelled');
                        setShowDialogCancel(false);
                    }}>Yes, cancel this campaign</Button>
                </>
                }
                isOpen={showDialogCancel} maxWidth="md">
                <p>Are you sure you wish to cancel this campaign?</p>
            </ModalWindow>
            <CampaignConfirmDialog isShown={showDialogConfirm}
                daybook={daybook}
                done={campaignConfirmed} 
                transientValues={transientValues}
                isAutoUpgrade={transientValues?.auto_upgrade} 
                setTransient={setTransient}
                setAutoUpgrade={setAutoUpgrade}
                values={values} 
                setValue={setValue} 
                />
            <div className="grid12">
                {options}
                <Card className="grid12-6">
                    <CardHeader title="Client Authorization Files" />
                    <CardContent>

                        <FormLabel>Client Authorization Files</FormLabel>
                        <FileInput showPreview={true} type={FileInputType.File} multiple={true}
                            maxThumbSize={320} label="Select any relevant File(s)"
                            name="authorizationFiles" showList={true}
                            allowDelete={user.hasPermission('campaigns.delete_confirmation_files')}
                            readOnly={readOnly}
                            fileType="AU" value={values.authorizationFiles}
                            {...field}
                        />
                    </CardContent>
                </Card>
            </div>
        </React.Fragment>
    );

};

CampaignStatusPane.propTypes = {
    values: PropTypes.any,
    setValue: PropTypes.func,
    onChange: PropTypes.func,
    loading: PropTypes.bool
};

export default CampaignStatusPane;